import type Vue from 'vue';
import { resolveInjected } from '~/utils/nuxt-instance';

/** Tears down the Featurebase feedback widget, injected by plugins/featurebase.js. */
export function useFeaturebase(): Vue['$featurebaseReset'] {
  return resolveInjected('$featurebaseReset');
}

/** Initializes the Featurebase feedback widget, injected by plugins/featurebase.js. */
export function useFeaturebaseInit(): Vue['$featurebase'] {
  return resolveInjected('$featurebase');
}